import React, { useCallback, useState } from 'react'
import { useAuth } from '../contexts/AuthContext' // your existing auth ctx
import AppContext from './AppContext'

type ModeOptions = {
  ASBESTOS_CLICK: string[]
  ADD_POLYGON?: string[]
}

const defaultModeOptions: ModeOptions = {
  ASBESTOS_CLICK: [],
  ADD_POLYGON: [],
}

export default function AppBridgeProvider({ children }: { children: React.ReactNode }) {
  const { me } = useAuth()
  const [modeOptions, setModeOptions] = useState<ModeOptions>(defaultModeOptions)

  const enterTeledetecionMode = useCallback((layer: any) => {
    setModeOptions((prev) => ({
      ...prev,
      ASBESTOS_CLICK: [...prev.ASBESTOS_CLICK, layer.id],
    }))
  }, [])

  const exitTeledetecionMode = useCallback((layer: any) => {
    setModeOptions((prev) => ({
      ...prev,
      ASBESTOS_CLICK: prev.ASBESTOS_CLICK.filter((id) => id !== layer.id),
    }))
  }, [])

  return (
    <AppContext.Provider
      value={{
        currentUser: me,
        modeOptions,
        setModeOptions,
        enterTeledetecionMode,
        exitTeledetecionMode,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
